"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.light = void 0;
exports.light = {
    ui: "200",
    menu: "200",
    tabs: "200",
    feedback: "200",
    field: "200",
    hover: "300",
    dark: {
        ui: "800",
        menu: "800",
        tabs: "800",
        feedback: "800",
        field: "800",
        hover: "700",
    },
};
exports.default = exports.light;
